import React from 'react';
import { Section } from './ui/Section';
export function Guarantee() {
  return <Section data-id="element-37">
      <div className="border border-sage/30 rounded-xl p-8 md:p-10 text-center bg-white/30" data-id="element-38">
        <p className="text-lg md:text-xl leading-relaxed text-warm-brown italic font-serif" data-id="element-39">
          "Si en 7 días no sentís que al menos{' '}
          <strong className="text-terracotta not-italic" data-id="element-40">1%</strong> de tu mundo
          interno se vuelve más habitable (porque te sostuviste), no es que
          'fallaste': simplemente este sistema no era tuyo."
        </p>
      </div>
    </Section>;
}